import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';

const FormRadioGroup = ({ name, label, options, defaultToFirstOption = true, ...restProps }) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState: { invalid } }) => {
        // const fieldValue = isString(field.value)
        //   ? find(options, opt => opt.value === field.value)
        //   : field.value;

        if (!field.value) {
          if (defaultToFirstOption) {
            field.value = get(options, '[0].value');
          } else {
            field.value = null;
          }
        }

        return (
          <FormControl error={invalid}>
            {label && (
              <FormLabel>
                {label}
              </FormLabel>
            )}
            <RadioGroup row name={name} value={field.value} onChange={field.onChange}>
              {options.map((opt) => {
                return <FormControlLabel key={opt.value} label={opt.label} value={opt.value} control={<Radio />} />;
              })}
            </RadioGroup>
          </FormControl>
        );
      }}
    />
  );
};

export default FormRadioGroup;
